module.exports = __webpack_public_path__ + "assets/35c5df512febff8f499cc070fb6ccb20.png";